import {
  bgColor,
  overlayScrim,
} from 'pages/styles';
import { lFColor, lFColor0 } from 'pages/components/LFHeader/LFHeader.styled';
import styled from 'styled-components';

export const MainContainer = styled.div`
  width: 100%;
  height: 100svh;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const Container = styled.div<{ isFitScreen: boolean }>`
  position: relative;
  z-index: 2;
  flex: 1;
  display: flex;
  flex-direction: ${({ isFitScreen }) => !isFitScreen && 'column'};
  overflow-y: auto;
`;

export const Page = styled.div`
  position: relative;
  display: flex;
  z-index: 13;
  flex: 1;
  width: 100%;
`;

export const DebugBg = styled.div`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background: black;
  color: white;
  font-size: 20px;
  font-weight: 500;
  max-height: 35vh;
  overflow: auto;
`;

export const Bg = styled.div`
  height: 100%;
  width: 100vw;
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 999;
  background: ${overlayScrim};
  opacity: 0;
  display: none;
  transition: opacity ease-in 250ms;
`;

export const BottomRightPanel = styled.div<{ isFitScreen: boolean }>`
  width: 100%;
  flex: 1;
  overflow-y: auto;
  z-index: 2;
  display: flex;
  background: ${bgColor};
  ${({ isFitScreen }) => !isFitScreen && 'min-height: 65svh'};
  ${({ isFitScreen }) => !isFitScreen && 'height: max-content'};
`;

/** Compact strip when marketing live-demo sessions are active. */
export const LiveViewBanner = styled.div`
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 8px 40px;
  background: linear-gradient(90deg, ${lFColor}, ${lFColor0});
  color: #fff;
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: 0.01em;
  text-align: center;
  z-index: 3;
`;

export const LiveViewBannerDismiss = styled.button`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #fff;
  cursor: pointer;
  opacity: 0.85;
  &:hover {
    opacity: 1;
    background: rgba(255, 255, 255, 0.12);
  }
`;
